/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { vendorTicketControllerCancel } from '../fn/vendor-ticket/vendor-ticket-controller-cancel';
import { VendorTicketControllerCancel$Params } from '../fn/vendor-ticket/vendor-ticket-controller-cancel';
import { vendorTicketControllerCreate } from '../fn/vendor-ticket/vendor-ticket-controller-create';
import { VendorTicketControllerCreate$Params } from '../fn/vendor-ticket/vendor-ticket-controller-create';
import { vendorTicketControllerFindAll } from '../fn/vendor-ticket/vendor-ticket-controller-find-all';
import { VendorTicketControllerFindAll$Params } from '../fn/vendor-ticket/vendor-ticket-controller-find-all';
import { vendorTicketControllerFindById } from '../fn/vendor-ticket/vendor-ticket-controller-find-by-id';
import { VendorTicketControllerFindById$Params } from '../fn/vendor-ticket/vendor-ticket-controller-find-by-id';
import { vendorTicketControllerSearchOffset } from '../fn/vendor-ticket/vendor-ticket-controller-search-offset';
import { VendorTicketControllerSearchOffset$Params } from '../fn/vendor-ticket/vendor-ticket-controller-search-offset';
import { VendorTicketDto } from '../models/vendor-ticket-dto';

@Injectable({ providedIn: 'root' })
export class VendorTicketService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `vendorTicketControllerFindAll()` */
  static readonly VendorTicketControllerFindAllPath = '/api/vendor-ticket';

  /**
   * 입점사 이용권 전체 조회.
   *
   * 입점사 이용권 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorTicketControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketControllerFindAll$Response(params?: VendorTicketControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorTicketDto>>> {
    return vendorTicketControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 이용권 전체 조회.
   *
   * 입점사 이용권 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorTicketControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketControllerFindAll(params?: VendorTicketControllerFindAll$Params, context?: HttpContext): Observable<Array<VendorTicketDto>> {
    return this.vendorTicketControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<VendorTicketDto>>): Array<VendorTicketDto> => r.body)
    );
  }

  /** Path part for operation `vendorTicketControllerSearchOffset()` */
  static readonly VendorTicketControllerSearchOffsetPath = '/api/vendor-ticket/search/offset';

  /**
   * 입점사 이용권 오프셋 기반 조회.
   *
   * 입점사 이용권을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorTicketControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketControllerSearchOffset$Response(params: VendorTicketControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return vendorTicketControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 이용권 오프셋 기반 조회.
   *
   * 입점사 이용권을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorTicketControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketControllerSearchOffset(params: VendorTicketControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.vendorTicketControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `vendorTicketControllerFindById()` */
  static readonly VendorTicketControllerFindByIdPath = '/api/vendor-ticket/{id}';

  /**
   * 입점사 이용권 ID 기반 조회.
   *
   * 입점사 이용권을 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorTicketControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketControllerFindById$Response(params: VendorTicketControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorTicketDto>> {
    return vendorTicketControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 이용권 ID 기반 조회.
   *
   * 입점사 이용권을 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorTicketControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  vendorTicketControllerFindById(params: VendorTicketControllerFindById$Params, context?: HttpContext): Observable<VendorTicketDto> {
    return this.vendorTicketControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorTicketDto>): VendorTicketDto => r.body)
    );
  }

  /** Path part for operation `vendorTicketControllerCreate()` */
  static readonly VendorTicketControllerCreatePath = '/api/vendor-ticket/{vendorWorkspaceId}';

  /**
   * 입점사 이용권 생성.
   *
   * 입점사 이용권을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorTicketControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorTicketControllerCreate$Response(params: VendorTicketControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorTicketDto>> {
    return vendorTicketControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 이용권 생성.
   *
   * 입점사 이용권을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorTicketControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorTicketControllerCreate(params: VendorTicketControllerCreate$Params, context?: HttpContext): Observable<VendorTicketDto> {
    return this.vendorTicketControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorTicketDto>): VendorTicketDto => r.body)
    );
  }

  /** Path part for operation `vendorTicketControllerCancel()` */
  static readonly VendorTicketControllerCancelPath = '/api/vendor-ticket/{ticketId}';

  /**
   * 입점사 이용권 취소.
   *
   * 입점사 이용권을 취소합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `vendorTicketControllerCancel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorTicketControllerCancel$Response(params: VendorTicketControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorTicketDto>> {
    return vendorTicketControllerCancel(this.http, this.rootUrl, params, context);
  }

  /**
   * 입점사 이용권 취소.
   *
   * 입점사 이용권을 취소합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `vendorTicketControllerCancel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  vendorTicketControllerCancel(params: VendorTicketControllerCancel$Params, context?: HttpContext): Observable<VendorTicketDto> {
    return this.vendorTicketControllerCancel$Response(params, context).pipe(
      map((r: StrictHttpResponse<VendorTicketDto>): VendorTicketDto => r.body)
    );
  }

}
